import { render, staticRenderFns } from "./BaseCover.vue?vue&type=template&id=bcea3850&scoped=true"
import script from "./BaseCover.vue?vue&type=script&lang=js"
export * from "./BaseCover.vue?vue&type=script&lang=js"
import style0 from "./BaseCover.vue?vue&type=style&index=0&id=bcea3850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcea3850",
  null
  
)

export default component.exports